"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _filter = _interopRequireDefault(require("@/components/filterDrawer/filter"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'income',
  components: {
    Pagination: _Pagination.default,
    drawer: _filter.default
  },
  computed: {
    deviceNameObj: function deviceNameObj() {
      return this.$store.state.user.deviceNameObj;
    }
  },
  data: function data() {
    var _this = this;
    return {
      form: {
        son_id: this.$route.query.son_id || ''
      },
      list: [],
      listLoading: true,
      total_profit: {},
      tableMaxH: '250',
      listQuery: {
        search_depend_type: -1,
        start: 1,
        limit: 20,
        page_num: 1
      },
      beginOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.form.end) {
            return time.getTime() > _this.form.end || time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          } else {
            return time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          }
        }
      },
      endOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.form.begin) {
            return time.getTime() < _this.form.begin || time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          } else {
            return time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          }
        }
      }
    };
  },
  mounted: function mounted(options) {
    this.getList();
    this.$store.dispatch('user/postSetRecode', [1, 1, 1]);
  },
  methods: {
    /**
     * 搜索查询
     */
    toQuery: function toQuery() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.$refs.filterDrawer.hide();
      if (type == 1) {
        this.form = {};
        this.listQuery.start = 1;
      } else {
        this.listQuery.start = 1;
      }
      this.getList();
    },
    /**
     * 获取列表
     */
    getList: function getList() {
      var _this2 = this;
      var listQuery = Object.assign({}, this.form, this.listQuery, {
          start: this.listQuery.start - 1
        }),
        url = 'agentapi/search/query_profit';
      if (listQuery.son_id > 0) {
        listQuery.search_user_type = 1;
      }
      if (listQuery.begin) listQuery.begin = this.parseTime(listQuery.begin, '{y}-{m}-{d}');
      if (listQuery.end) listQuery.end = this.parseTime(listQuery.end, '{y}-{m}-{d}');
      this.$get(url, listQuery).then(function (res) {
        _this2.listLoading = false;
        _this2.list = res.list;
        _this2.total_profit = {
          all_total_profit: res.all_total_profit,
          my_total_profit: res.my_total_profit,
          son_total_profit: res.son_total_profit,
          my_today_profit: res.my_today_profit
        };
        _this2.listQuery.page_num = res.page_num;
        if (listQuery.start == 0) _this2.tableMaxH = window.innerHeight - _this2.$refs.list_table.$el.offsetTop - 83;
      }).catch(function () {
        _this2.listLoading = false;
      });
    }
  }
};